// Single source of truth for the brand identity.
// Rename the platform here — no other file hardcodes the brand name.
export const BRAND = {
  name: "AOS Equestrian",
  legalName: "Equestrian Partners, Inc.",
  domain: "aosequestrian.com",
  foundedYear: 2025,
  logo: "/images/brand/logo-trimmed.png",
  poweredBy: "Equestrian Partners",
};
